import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Compass, X, Menu } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useLanguage } from "../../contexts/LanguageContext";

export default function LandingNavbar() {
  const { user } = useAuth();
  const { lang, t, toggleLang } = useLanguage();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav
      className="sticky top-0 z-50 border-b border-[#DCD4C6]"
      style={{ backdropFilter: "blur(16px)", background: "rgba(249,246,240,0.9)" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <div
            className="flex items-center gap-2"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic", fontWeight: 600, fontSize: "1.5rem", color: "#2B2623" }}
          >
            <div className="w-8 h-8 rounded-full border-2 border-[#C17F59] flex items-center justify-center">
              <Compass size={16} color="#C17F59" strokeWidth={1.5} />
            </div>
            Voyage-r
          </div>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm text-[#5C554E] hover:text-[#2B2623] transition-colors"
              style={{ fontFamily: "'Lora', Georgia, serif" }}
              data-testid="landing-about-link"
            >
              {t("landing.about")}
            </Link>
            {user ? (
              <button
                onClick={() => navigate("/dashboard")}
                className="btn-primary text-sm"
                data-testid="landing-dashboard-btn"
              >
                {t("landing.my_trips")}
              </button>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 text-sm text-[#5C554E] hover:text-[#2B2623] transition-colors"
                  style={{ fontFamily: "'Lora', Georgia, serif" }}
                  data-testid="landing-login-link"
                >
                  {t("landing.login")}
                </Link>
                <button
                  onClick={toggleLang}
                  className="text-xs px-2 py-1 border border-[#DCD4C6] text-[#9A8F86] hover:border-[#C17F59] hover:text-[#C17F59] transition-all"
                  style={{ fontFamily: "'Lora', Georgia, serif", borderRadius: "2px", letterSpacing: "0.06em" }}
                  data-testid="lang-toggle-btn"
                >
                  {lang === "fr" ? "EN" : "FR"}
                </button>
                <Link to="/register" className="btn-primary text-sm" data-testid="landing-cta-btn">
                  {t("landing.start")}
                </Link>
              </>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 text-[#5C554E] hover:text-[#2B2623]"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="landing-mobile-menu-btn"
            aria-label="Menu"
          >
            {menuOpen ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden pb-4 border-t border-[#DCD4C6] mt-1 animate-fade-in">
            <div className="pt-3 flex flex-col gap-2">
              <Link
                to="/about"
                className="py-2.5 px-3 text-sm text-[#5C554E] hover:bg-[#F1EBE1]"
                onClick={() => setMenuOpen(false)}
                style={{ fontFamily: "'Lora', Georgia, serif" }}
              >
                {t("landing.about")}
              </Link>
              {user ? (
                <button
                  onClick={() => { setMenuOpen(false); navigate("/dashboard"); }}
                  className="btn-primary text-center text-sm mx-3"
                  data-testid="mobile-dashboard-btn"
                >
                  {t("landing.my_trips")}
                </button>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="btn-secondary text-center text-sm mx-3"
                    onClick={() => setMenuOpen(false)}
                    data-testid="mobile-login-btn"
                  >
                    {t("landing.login")}
                  </Link>
                  <Link
                    to="/register"
                    className="btn-primary text-center text-sm mx-3"
                    onClick={() => setMenuOpen(false)}
                    data-testid="mobile-register-btn"
                  >
                    {t("landing.start")}
                  </Link>
                  <div className="px-3 pt-1">
                    <button
                      onClick={toggleLang}
                      className="text-xs px-2 py-1 border border-[#DCD4C6] text-[#9A8F86]"
                      style={{ fontFamily: "'Lora', Georgia, serif", borderRadius: "2px" }}
                    >
                      {lang === "fr" ? "EN" : "FR"}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
